import type { Role } from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { CustomRoleNameSelection } from './customRoleNameSelection';
import { CustomRoleScopesSelection } from './customRoleScopesSelection';

export type UpsertCustomRoleState = Role;

export const UpsertCustomRoleFlow: Step<UpsertCustomRoleState> = {
  id: 'name_selection',
  Component: CustomRoleNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'scopes_selection',
      Component: CustomRoleScopesSelection,
    },
  ],
};
